class OurJournal extends HTMLElement {
    constructor() {
        super();
        this.flkty = null;
        this.checkViewportAndToggleFlickity = this.checkViewportAndToggleFlickity.bind(this);
        window.addEventListener('resize', this.checkViewportAndToggleFlickity);
    }

    connectedCallback() {
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", this.checkViewportAndToggleFlickity);
    }

    createFlickity(carousel) {
        return new Flickity(carousel, {
            cellAlign: "center",
            wrapAround: true,
            freeScroll: false,
            pageDots: false,
            prevNextButtons: true,
            arrowShape: { "x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25 }
        });
    }

    checkViewportAndToggleFlickity() {
        const viewportWidth = window.innerWidth;
        const carousel = document.querySelector('.journal-carousel');
        const itemsCount = parseInt(carousel.getAttribute('data-count'), 10);

        if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
        }

        if (viewportWidth >= 800) {
            this.flkty = this.createFlickity(carousel);
        }
    }
}

// Define the new element
customElements.define('our-journal', OurJournal);
